import { Controller } from "@hotwired/stimulus"

// Envoi du fichier de l'import de collaborateurs. Pas de spinner : dès l'envoi, l'aperçu reçoit
// le squelette du tableau (template rendu par le serveur), que la réponse puis le job remplacent.
// La zone de statut ne sert qu'aux erreurs et à la fin de l'analyse (diffusée par le job).
export default class extends Controller {
  static targets = ["form", "status", "fileInput", "skeleton"]
  static values = { previewFrameId: String }

  connect() {
    this.submitting = false
    this.boundSubmitStarted = this.submitStarted.bind(this)
    this.boundSubmitFinished = this.submitFinished.bind(this)
    this.boundSubmitFailed = this.submitFailed.bind(this)

    if (this.hasFormTarget) {
      this.formTarget.addEventListener("turbo:submit-start", this.boundSubmitStarted)
      this.formTarget.addEventListener("turbo:submit-end", this.boundSubmitFinished)
      this.formTarget.addEventListener("turbo:fetch-request-error", this.boundSubmitFailed)
    }
  }

  disconnect() {
    if (!this.hasFormTarget) return

    this.formTarget.removeEventListener("turbo:submit-start", this.boundSubmitStarted)
    this.formTarget.removeEventListener("turbo:submit-end", this.boundSubmitFinished)
    this.formTarget.removeEventListener("turbo:fetch-request-error", this.boundSubmitFailed)
  }

  submitForm() {
    if (!this.hasFormTarget || this.submitting) return

    const input = this.hasFileInputTarget ? this.fileInputTarget : this.formTarget.querySelector('input[type="file"]')
    if (!input?.files?.length) {
      this.showError(this.statusText("missing_file"))
      return
    }

    this.submitting = true
    this.formTarget.requestSubmit()
  }

  submitStarted() {
    this.clearStatus()
    this.showSkeleton()
  }

  submitFinished() {
    this.submitting = false
  }

  submitFailed() {
    this.submitting = false
    this.clearPreview()
    this.showError(this.statusText("failed_upload"))
  }

  showSkeleton() {
    const frame = this.previewFrame
    if (!frame || !this.hasSkeletonTarget) return

    frame.replaceChildren(this.skeletonTarget.content.cloneNode(true))
  }

  clearPreview() {
    this.previewFrame?.replaceChildren()
  }

  get previewFrame() {
    return this.previewFrameIdValue ? document.getElementById(this.previewFrameIdValue) : null
  }

  showError(message) {
    if (!this.hasStatusTarget) return

    const alert = document.createElement("div")
    alert.className = "alert alert-danger small mb-3"
    alert.setAttribute("role", "alert")
    alert.textContent = message
    this.statusTarget.replaceChildren(alert)
  }

  clearStatus() {
    if (this.hasStatusTarget) this.statusTarget.replaceChildren()
  }

  statusText(key) {
    return this.element.dataset[`companyEmploymentsImport${this.camelize(key)}Value`] || key
  }

  camelize(value) {
    return value.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()).replace(/^./, (letter) => letter.toUpperCase())
  }
}
